import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import AccessInformationIcon from '@/svg-icons/AccessInformation';

const CancelSectionComponent = ({ order }) => {
  const cancelData = order.messages?.cancel || {};
  
  return (
    <div className="w-full">
      <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
        <AccessInformationIcon 
          viewBox="0 0 34.016 34.016" 
          className="text-gray-700 mr-2 w-6 h-6 shrink-0" 
        />
        <FormattedMessage id="cancelInformation" />
      </div>

      <div className="flex flex-wrap text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)]">
        <div className="w-1/2 mb-[1vw]" data-cy="order-details-cancel-reason">
          <div className="font-bold">Motivo do cancelamento</div>
          <span>{cancelData.reason}</span>
        </div>
        <div className="w-1/2 mb-[1vw]" data-cy="order-details-cancel-observation">
          <div className="font-bold">Observações</div>
          <span>{cancelData.observation || '-----'}</span>
        </div>
        <div className="w-1/2 mb-[1vw]" data-cy="order-details-cancel-should-be-charged">
          <div className="font-bold">Taxa de deslocamento cobrada?</div>
          <span>{cancelData.should_be_charged ? 'Sim' : 'Não'}</span>
        </div>
        <div className="w-1/2 mb-[1vw]" data-cy="order-details-cancel-send-photo-to-client">
          <div className="font-bold">Foto enviada ao cliente?</div>
          <span>{cancelData.send_photo_to_client ? 'Sim' : 'Não'}</span>
        </div>

        {cancelData.photo && (
          <div className="w-full mt-[1vw]">
            <div className="font-bold mb-[0.5vw]">Foto enviada pelo vistoriador</div>
            <div className="border border-[#DEDEDE] p-1 inline-block">
              <img 
                src={cancelData.photo} 
                alt="Foto enviada pelo vistoriador" 
                className="h-[calc(100px+8vw)] object-contain"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

CancelSectionComponent.propTypes = {
  order: PropTypes.object.isRequired,
};

export default CancelSectionComponent;
